export type LoadScriptWindowTarget<T> = Window & typeof globalThis & Record<string, T>
export interface LoadScriptOptions {
  url: string
  globalName?: string
  reuseGlobal?: boolean
  resolveGlobal?: boolean
  defer?: boolean
  retryDelay?: number
  maxTries?: number
}
// TODO: add global promise per script
export async function loadScript<T> (opts: LoadScriptOptions): Promise<T> {
  const {
    url = '',
    globalName = '',
    reuseGlobal = false,
    resolveGlobal = true,
    defer = true,
    retryDelay = 100,
    maxTries = 10
  } = opts

  let retries = maxTries
  const target: LoadScriptWindowTarget<T> = window as LoadScriptWindowTarget<T>

  if (reuseGlobal && target[globalName] != null) {
    return target[globalName] as T
  }

  return await new Promise((resolve, reject) => {
    const scr = document.createElement('script')
    scr.defer = defer
    scr.src = url
    scr.addEventListener('error', (e) => { reject(e.error) })
    scr.addEventListener('load', load)

    document.body.appendChild(scr)

    // NOTE: this load retry approach is not ideal. It would be better to
    // use a promise per script, but that would require a global map of
    // promises, which would need to be cleaned up after the script is
    // loaded. This is a quick and dirty approach that should work for
    // most cases. If it doesn't, we can revisit this.
    function load () {
      if (resolveGlobal && target[globalName] == null) {
        if (retries > 0) {
          retries -= 1
          return setTimeout(load, retryDelay)
        }

        reject(new Error('loadScript: could not resolve globalName')); return
      }

      // resolve the global even if it wasn't asked for
      // because, why not?
      resolve(target[globalName])
    }
  })
}
